var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnpaidInvoice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 80,
    viewBox: "0 0 93 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "transparent"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_580_17143)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1227,
    y: -592,
    width: 1440,
    height: 1024,
    rx: 20,
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_580_17143)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_580_17143)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1204 37.0202C57.4973 37.0202 56.9922 36.515 56.9922 35.892V35.262C56.9922 34.6389 57.4973 34.1338 58.1204 34.1338C58.7434 34.1338 59.2486 34.6389 59.2486 35.262V35.892C59.2486 36.515 58.7434 37.0202 58.1204 37.0202Z",
    fill: "#3BBEE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1196 33.142C58.7426 33.142 59.2478 32.6369 59.2478 32.0138V28.1154C59.2478 26.949 58.2988 26 57.1324 26H37.3888C36.2224 26 35.2734 26.949 35.2734 28.1154V56.8846C35.2734 58.051 36.2224 59 37.3888 59H51.1811C51.4798 59 51.7662 58.8815 51.9777 58.6706L58.9162 51.7509C59.1285 51.5393 59.2478 51.2518 59.2478 50.9521V39.2256C59.2478 38.6025 58.7426 38.0974 58.1196 38.0974C57.4965 38.0974 56.9914 38.6025 56.9914 39.2256V49.8239H51.1811C50.5581 49.8239 50.0529 50.329 50.0529 50.9521V56.7436H37.5298V28.2564H56.9914V32.0138C56.9914 32.6369 57.4965 33.142 58.1196 33.142ZM55.3907 52.0803L52.3093 55.1532V52.0803H55.3907Z",
    fill: "#3BBEE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4957 40.8775H41.4671C40.844 40.8775 40.3389 40.3724 40.3389 39.7493C40.3389 39.1262 40.844 38.6211 41.4671 38.6211H53.4957C54.1188 38.6211 54.6239 39.1262 54.6239 39.7493C54.6239 40.3724 54.1188 40.8775 53.4957 40.8775Z",
    fill: "#3BBEE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4957 36.6461H41.4671C40.844 36.6461 40.3389 36.1409 40.3389 35.5179C40.3389 34.8948 40.844 34.3896 41.4671 34.3896H53.4957C54.1188 34.3896 54.6239 34.8948 54.6239 35.5179C54.6239 36.1409 54.1188 36.6461 53.4957 36.6461Z",
    fill: "#3BBEE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4957 32.4166H41.4671C40.844 32.4166 40.3389 31.9114 40.3389 31.2884C40.3389 30.6653 40.844 30.1602 41.4671 30.1602H53.4957C54.1188 30.1602 54.6239 30.6653 54.6239 31.2884C54.6239 31.9114 54.1188 32.4166 53.4957 32.4166Z",
    fill: "#3BBEE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5633 47.9396C43.3044 47.4186 43.0919 47.14 43.0919 46.7124C43.0919 46.3164 43.3786 45.8934 44.1834 45.8934C44.9037 45.8934 45.4778 46.1689 46.0833 46.5149L46.6756 44.9513C46.0912 44.6088 45.5037 44.3663 44.822 44.2981V42.9541H43.2723V44.3954C42.0127 44.7104 41.2153 45.6578 41.2153 46.8757C41.2153 48.3876 42.4647 49.0814 43.6831 49.5592C44.8425 50.0292 45.0023 50.4591 45.0023 50.8535C45.0023 51.4412 44.4926 51.836 43.7338 51.836C42.9191 51.836 42.2501 51.4976 41.5923 51.0591L41.0234 52.6474C41.6611 53.1163 42.3868 53.3739 43.1769 53.448V54.8433H44.7402V53.3604C46.0397 53.0317 46.8926 52.0168 46.8926 50.7582C46.8926 49.1018 45.6469 48.3814 44.5633 47.9396C45.6469 48.3814 43.3043 47.4186 44.5633 47.9396Z",
    fill: "#3BBEE8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_580_17143",
    x: -110.444,
    y: -29.619,
    width: 312.889,
    height: 436.889,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.8254
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.22222
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.517647 0 0 0 0 0.67451 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_580_17143"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_580_17143",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_580_17143",
    x: 0.425532,
    y: 0.468085,
    width: 92.1489,
    height: 92.1489,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.04255
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.28723
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.745098 0 0 0 0 0.909804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_580_17143"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_580_17143",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_580_17143"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1199,
    y: -366,
    width: 1440,
    height: 1024,
    rx: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpaidInvoice);
export default __webpack_public_path__ + "static/media/unpaidInvoice.36c2d29dd2f5ea9ec7cc2afcbc618bf5.svg";
export { ForwardRef as ReactComponent };